import React from 'react';

import { ComboboxOptionActionProps, Size } from '@lumapps/lumx/react';
import { Link } from '@lumapps/router';
import { useSocialProfileRoute } from '@lumapps/user-profile/hooks/useSocialProfileRoute';
import { UserAvatar } from '@lumapps/user-ui/components/UserAvatar';

import { SearchBoxOptionWithItemProps } from '../../types';
import { BaseSearchBoxInteractionOption } from './BaseSearchBoxInteraction';

/**
 * Search box options for users.
 * Generates the link to the user and displays user avatar
 */
export const SearchBoxInteractionUser = ({ suggestion, ...forwardedProps }: SearchBoxOptionWithItemProps) => {
    const { item } = suggestion;
    const { route } = useSocialProfileRoute({
        routeParams: { userId: item?.entityId },
    });
    const actionProps: ComboboxOptionActionProps<typeof Link> = {
        as: Link,
        to: route,
        ...(forwardedProps.actionProps as ComboboxOptionActionProps<typeof Link>),
    };

    return (
        <BaseSearchBoxInteractionOption
            suggestion={suggestion}
            {...forwardedProps}
            actionProps={actionProps}
            before={
                <UserAvatar user={{ id: item.entityId, fullName: item.title }} size={Size.s} avatarAs="image" alt="" />
            }
        />
    );
};
